import { SET_UNIVERSITETER, SET_SATSER, SatserActionTypes, UniversitTypes } from './Types';
import { StamdataUtlandHelgradModel } from '../../Models/StamdataUtlandHelgradModel';
import LandOgUniversitetModel from '../../../Shared/Scripts/Models/LandOgUniversitetModel';

const initialState: StamdataUtlandHelgradModel | null = null;
const universitetInitialState: Array<LandOgUniversitetModel> | null = null;

export function satserReducer(state: StamdataUtlandHelgradModel | null = initialState, action: SatserActionTypes): StamdataUtlandHelgradModel | null {
    switch (action.type) {
        case SET_SATSER: {
            return action.payload;
        }
        default:
            return state;
    }
}

export function universiteterReducer(state: Array<LandOgUniversitetModel> | null = universitetInitialState, action: UniversitTypes): Array<LandOgUniversitetModel> | null {
    switch (action.type) {
        case SET_UNIVERSITETER: {
            return action.payload;
        }
        default:
            return state;
    }
}
